import type { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';

export const sectionSx: SxProps<Theme> = {
  mb: 1,
};

/** Spacing between domain blocks (Issues vs Inspections) on the analytics dashboard. */
export const inspectionsDomainSectionSx: SxProps<Theme> = {
  mt: 3,
};

export const domainHeadingSx: SxProps<Theme> = {
  fontFamily: 'Archivo',
  fontSize: '1.25rem',
  fontWeight: 700,
  color: Color.black,
  m: '0 0 16px 0',
};

export const sectionLabelSx: SxProps<Theme> = {
  fontFamily: 'Archivo',
  fontSize: '0.75rem',
  fontWeight: 600,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: Color.iconGray,
  m: '0 0 16px 0',
};

export const inspectionSummarySubsectionSx: SxProps<Theme> = {
  mt: 3,
};
